module.exports = __webpack_public_path__ + "3ac1d6b2786c0560242343ca4a179f4a.png";